<template>
  <div class="resetta-password">
    <h3>{{ labels.resetta_password }}</h3>
    <p style="text-align: justify">{{ labels.stai_richiedendo_il_reset }}.</p>
    <p style="text-align: justify">{{ labels.nota }}.</p>

    <b-form-row class="b-form-row">
      <b-col xs="12" sm="6" md="6" lg="3" xl="3">
        <b-form-group v-bind:label="labels.utente">
          <b-form-input
            :size="size"
            class="b-form-input"
            :id="utente"
            v-model="utente_collegato"
            maxlength="45"
          ></b-form-input>
          <p class="errore" id="errore-utente" v-if="isError(errori.utente)">
            {{ labels_errori[errori.utente] }}
          </p>
        </b-form-group>
      </b-col>
    </b-form-row>

    <b-button variant="success" @click="resetta" :disabled="invio_in_corso">{{
      labels.resetta
    }}</b-button>

    <br />
    <br />
    <br />
  </div>
</template>

<script>
import { utility } from "@/utility";
import router from "@/router/index";
const axios = require("axios");

export default {
  name: "ResettaPassword",
  data() {
    return {
      utente_collegato: "",
      labels: {},
      size: "sm",
      errori: {},
      invio_in_corso: false,
    };
  },
  watch: {
    "$store.state.Lingua"(Lingua) {
      fn_CambiaLingua(Lingua, this);
    },
  },
  mixins: [utility],
  props: {
    utente: String,
  },
  created() {
    fn_CambiaLingua(this.$store.state.Lingua, this);
    this.utente_collegato = this.utente;
  },
  methods: {
    resetta() {
      try {
        let me = this;

        if (!fn_ControllaDati(this)) {
          return;
        }

        let ServerURL = this.$store.state.ServerURL;

        let parametri = {
          utente: this.utente_collegato,
          url: this.$store.state.LocalURL + "home/reintroducipassword",
        };
        let parametri_json = JSON.stringify(parametri);

        fn_CambiaCursore("wait", this);
        this.invio_in_corso = true;

        axios({
          method: "post",
          url: ServerURL + "CheckIn/ResettaPassword",
          data: parametri_json,
        })
          .then(function (response) {
            me.invio_in_corso = false;
            fn_CambiaCursore("default", me);
            if (response.data.errore == 0) {
              router.push({
                name: "EmailResetInviata",
                params: { utente: me.utente_collegato },
              });
            } else if (response.data.errore == -2) {
              me.registraErrore(response.data.esito, "ResettaPassword-resetta");
            } else {
              me.$bvModal.msgBoxOk(me.labels_errori[response.data.esito], {
                title: me.labels_errori.si_e_verificato_un_errore,
                bodyClass: "errore",
              });
            }
          })
          .catch(function (error) {
            me.invio_in_corso = false;
            fn_CambiaCursore("default", me);
            me.registraErrore(error, "ResettaPassword-resetta");
          });
      } catch (error) {
        this.invio_in_corso = false;
        this.registraErrore(error, "ResettaPassword-resetta");
      }
    },
  },
};

function fn_CambiaLingua(lingua, vm) {
  try {
    let labels_italiano = {
      resetta_password: "Resetta password",
      stai_richiedendo_il_reset:
        "Stai richiedendo il reset della password per l'utente indicato. Verrà inviata un'email contenente un link attraverso il quale sarà possibile inserire una nuova password. Se l'email non ti sarà arrivata entro un tempo ragionevole, controlla nella posta indesiderata (spam)",
      nota: "NOTA: l'indirizzo email a cui verrà inviato il messaggio è quello indicato in fase di creazione/modifica dell'utente",
      utente: "Utente",
      resetta: "Resetta",
    };
    let labels_inglese = {
      resetta_password: "Resetta password",
      stai_richiedendo_il_reset:
        "Stai richiedendo il reset della password per l'utente indicato. Verrà inviata un'email contenente un link attraverso il quale sarà possibile inserire una nuova password. Se l'email non ti sarà arrivata entro un tempo ragionevole, controlla nella posta indesiderata (spam)",
      nota: "NOTA: l'indirizzo email a cui verrà inviato il messaggio è quello indicato in fase di creazione/modifica dell'utente",
      utente: "Utente",
      resetta: "Resetta",
    };
    let labels_tedesco = {
      resetta_password: "Resetta password",
      stai_richiedendo_il_reset:
        "Stai richiedendo il reset della password per l'utente indicato. Verrà inviata un'email contenente un link attraverso il quale sarà possibile inserire una nuova password. Se l'email non ti sarà arrivata entro un tempo ragionevole, controlla nella posta indesiderata (spam)",
      nota: "NOTA: l'indirizzo email a cui verrà inviato il messaggio è quello indicato in fase di creazione/modifica dell'utente",
      utente: "Utente",
      resetta: "Resetta",
    };
    let labels_francese = {
      resetta_password: "Resetta password",
      stai_richiedendo_il_reset:
        "Stai richiedendo il reset della password per l'utente indicato. Verrà inviata un'email contenente un link attraverso il quale sarà possibile inserire una nuova password. Se l'email non ti sarà arrivata entro un tempo ragionevole, controlla nella posta indesiderata (spam)",
      nota: "NOTA: l'indirizzo email a cui verrà inviato il messaggio è quello indicato in fase di creazione/modifica dell'utente",
      utente: "Utente",
      resetta: "Resetta",
    };

    let labels_errori_italiano = {
      dato_obbligatorio: "Dato obbligatorio",
      utente_non_trovato: "Utente non trovato",
      utente_senza_email: "Utente senza indirizzo email",
      si_e_verificato_un_errore: "Si è verificato un errore",
      si_sono_verificati_degli_errori: "Si sono verificati degli errori",
      url_errato: "Url locale errato",
    };
    let labels_errori_inglese = {
      dato_obbligatorio: "Dato obbligatorio",
      utente_non_trovato: "Utente non trovato",
      utente_senza_email: "Utente senza indirizzo email",
      si_e_verificato_un_errore: "Si è verificato un errore",
      si_sono_verificati_degli_errori: "Si sono verificati degli errori",
      url_errato: "Url locale errato",
    };
    let labels_errori_tedesco = {
      dato_obbligatorio: "Dato obbligatorio",
      utente_non_trovato: "Utente non trovato",
      utente_senza_email: "Utente senza indirizzo email",
      si_e_verificato_un_errore: "Si è verificato un errore",
      si_sono_verificati_degli_errori: "Si sono verificati degli errori",
      url_errato: "Url locale errato",
    };
    let labels_errori_francese = {
      dato_obbligatorio: "Dato obbligatorio",
      utente_non_trovato: "Utente non trovato",
      utente_senza_email: "Utente senza indirizzo email",
      si_e_verificato_un_errore: "Si è verificato un errore",
      si_sono_verificati_degli_errori: "Si sono verificati degli errori",
      url_errato: "Url locale errato",
    };

    switch (lingua) {
      case "IT":
        vm.labels = labels_italiano;
        vm.labels_errori = labels_errori_italiano;
        break;
      case "EN":
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        break;
      case "DE":
        vm.labels = labels_tedesco;
        vm.labels_errori = labels_errori_tedesco;
        break;
      case "FR":
        vm.labels = labels_francese;
        vm.labels_errori = labels_errori_francese;
        break;
      default:
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        break;
    }
  } catch (error) {
    vm.registraErrore(error, "ResettaPassword-fn_CambiaLingua");
  }
}

function fn_ControllaDati(vm) {
  try {
    let esito = true;

    vm.errori = {};

    if (vm.utente_collegato.trim() == "") {
      vm.errori.utente = "dato_obbligatorio";
      esito = false;
    }

    if (esito) {
      return true;
    } else {
      vm.errori.invia = "si_sono_verificati_degli_errori";
      return false;
    }
  } catch (error) {
    vm.registraErrore(error, "ResettaPassword-fn_ControllaDati");
  }
}
function fn_CambiaCursore(cursore, vm) {
  document.querySelector("body").style.cursor = cursore;

  if (cursore == "wait") {
    vm.invio_in_corso = true;
  } else {
    vm.invio_in_corso = false;
  }
}
</script>
<style scoped></style>
